export default "__VITE_ASSET__BiMLJoVh__"